import {
  Popover,
  PopoverHandler,
  PopoverContent,
  Button,
  Option,
  Select
} from '@material-tailwind/react'

import { CiFilter } from 'react-icons/ci'

import DatePicker from '@/Shared/DatePicker'

export default function ({ values, setValues }) {
  function reset() {
    setValues({
      service: '',
      startDate: '',
      endDate: ''
    })
  }

  return (
    <Popover placement="bottom">
      <PopoverHandler>
        <Button
          size="sm"
          type="button"
          variant="text"
          className="custom-hidden"
        >
          <CiFilter size={25} />
        </Button>
      </PopoverHandler>

      <PopoverContent className="w-96">
        <Button
          size="md"
          onClick={reset}
          type="reset"
          variant="text"
          color="blue-gray"
        >
          Reset
        </Button>

        <div className="flex flex-col gap-4">
          <DatePicker
            label="Select Start Date"
            date={values.startDate}
            maxDate={values.endDate}
            setDate={date =>
              setValues(prev => ({
                ...prev,
                startDate: date
              }))
            }
          />

          <DatePicker
            label="Select End Date"
            date={values.endDate}
            minDate={values.startDate}
            setDate={date =>
              setValues(prev => ({
                ...prev,
                endDate: date
              }))
            }
          />

          <div className="w-72">
            <Select
              label="Select Service"
              onChange={value =>
                setValues(prev => ({
                  ...prev,
                  service: value
                }))
              }
              value={values.service}
            >
              <Option value="janitorial">Janitorial</Option>
              <Option value="security">Security</Option>
              <Option value="ct-scan">CT Scan</Option>
              <Option value="mepg">MEPG</Option>
            </Select>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}
